import { fetchData, apiURL } from "../api-helper";

const getLockedItems = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/lock`;
    fetchData(endpointURL, "get", payload)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

const deleteLockedItems = (payload) =>
  new Promise((resolve, reject) => {
    const endpointURL = `${apiURL}/admin/lock/${payload}`;
    fetchData(endpointURL, "delete")
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });

export default {
  getLockedItems,
  deleteLockedItems,
};
